import { useContext } from "react";
import WithdrawApi from "../api/withdraw";
import AuthContext from "../components/auth-context";
import SGrid from "../components/sgrid";

function Withdraws() {
  const context = useContext(AuthContext);

  const dataProvider = (page: number, pageSize: number) =>
    new WithdrawApi(context).getAll(page, pageSize);
  console.log("dataProvider", dataProvider);
  dataProvider(1, 10).then((data) => console.log("Fetched Data:", data));

  return (
    <>
      <div className="card dcard overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          dataProvider={dataProvider}
          urlAddress={"/withdraw-detail"}
          columns={[
            ["سریال", "link", 0],
            ["تاریخ", "date", 1],
            ["مبلغ (ریال)", "rial", 2],
            "",
            "",
            "",
            ["توضیحات", "description", 6],
          ]}
        />
      </div>
    </>
  );
}

export default Withdraws;
